import React from "react";
import PropTypes from "prop-types";
import Skeleton from "react-loading-skeleton";

function VisibilityBadge({ value = null }) {
  const colorClasses = { hidden: "danger", network: "info", public: "success" };
  const badgeTexts = { hidden: "Hidden", network: "Network Only", public: "Public" };

  if (!value) {
    return <Skeleton containerClassName="ms-auto me-2" width="20%" />;
  }

  return <div className={`badge bg-${colorClasses[value]} ms-auto me-2`}>Visibility: {badgeTexts[value]}</div>;
}

VisibilityBadge.propTypes = {
  value: PropTypes.oneOf(["hidden", "network", "public"]),
};

export default VisibilityBadge;
